// Bootstrap import
import('./bootstrap')
    .catch(err => console.error('Bootstrap import failed:', err));

// Microsoft Clarity integration
import { environment } from './environments/environment';
if (typeof window !== 'undefined' && environment.env === 'staging') {
    import('@microsoft/clarity')
        .then(module => {
            console.log('Clarity module loaded');
            module.default.init('su97nzttv0');
        })
        .catch(err => console.error('Clarity import failed:', err));
}
